import { render, staticRenderFns } from "./SaveDesktop.vue?vue&type=template&id=25e405bd"
import script from "./SaveDesktop.vue?vue&type=script&lang=js"
export * from "./SaveDesktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports